export const ITEMS_HAS_ERRORED = "ITEMS_HAS_ERRORED"
export const ITEMS_IS_LOADING = "ITEMS_IS_LOADING"
export const CATEGORIES_FETCH_DATA_SUCCESS = "CATEGORIES_FETCH_DATA_SUCCESS"
export const POSTS_FETCH_DATA_SUCCESS = "POSTS_FETCH_DATA_SUCCESS"
export const SET_ACTIVE_CATEGORY = "SET_ACTIVE_CATEGORY"
export const SINGLE_POST_FETCH_DATA_SUCCESS = "SINGLE_POST_FETCH_DATA_SUCCESS"
export const ADD_POST = "ADD_POST"
export const ADD_CATEGORY = "ADD_CATEGORY"
export const UPDATE_USER = "UPDATE_USER"
export const CONTROL_MODAL = "CONTROL_MODAL"
export const ADD_COMMENT = "ADD_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const COMMENTS_FETCH_DATA_SUCCESS = "COMMENTS_FETCH_DATA_SUCCESS"
export const STATIC_CATEGORIES_FETCH_DATA_SUCCESS =
  "STATIC_CATEGORIES_FETCH_DATA_SUCCESS"
export const UPDATE_COMMENT = "UPDATE_COMMENT"
export const ADD_RESPONSE = "ADD_RESPONSE"
export const RESPONSES_FETCH_DATA_SUCCESS = "RESPONSES_FETCH_DATA_SUCCESS"
export const DELETE_RESPONSE = "DELETE_RESPONSE"
export const DELETE_POST = "DELETE_POST"
export const ALERT_STATE_CHANGE = "ALERT_STATE_CHANGE"

export function itemsHasErrored(bool) {
  return {
    type: "ITEMS_HAS_ERRORED",
    hasErrored: bool,
  }
}
export function itemsIsLoading(bool) {
  return {
    type: "ITEMS_IS_LOADING",
    isLoading: bool,
  }
}
export function categoriesFetchDataSuccess(items) {
  return {
    type: "CATEGORIES_FETCH_DATA_SUCCESS",
    items,
  }
}

export function staticCategoriesFetchDataSuccess(items) {
  return {
    type: "STATIC_CATEGORIES_FETCH_DATA_SUCCESS",
    items,
  }
}

export function postsFetchDataSuccess(items) {
  return {
    type: "POSTS_FETCH_DATA_SUCCESS",
    items,
  }
}

export function setActiveCategory(category) {
  return {
    type: "SET_ACTIVE_CATEGORY",
    category,
  }
}

export function singlePostFetchDataSuccess(item) {
  return {
    type: "SINGLE_POST_FETCH_DATA_SUCCESS",
    item,
  }
}

export function addPost(post) {
  return {
    type: "ADD_POST",
    post,
  }
}

export function addCategory(category) {
  return {
    type: "ADD_CATEGORY",
    category,
  }
}

export function updateUser(user) {
  return {
    type: "UPDATE_USER",
    user,
  }
}

export function controlModal(bool) {
  return {
    type: "CONTROL_MODAL",
    bool,
  }
}

export function addComment(comment) {
  return {
    type: "ADD_COMMENT",
    comment,
  }
}

export function deleteComment(commentId) {
  return {
    type: "DELETE_COMMENT",
    commentId,
  }
}

export function commentsFetchDataSuccess(items) {
  return {
    type: "COMMENTS_FETCH_DATA_SUCCESS",
    items,
  }
}

export function updateComment(commentId, body) {
  return {
    type: "UPDATE_COMMENT",
    commentId,
    body,
  }
}

export function addResponse(response) {
  return {
    type: "ADD_RESPONSE",
    response,
  }
}

export function responsesFetchDataSuccess(items) {
  return {
    type: "RESPONSES_FETCH_DATA_SUCCESS",
    items,
  }
}

export function deleteResponse(responseID) {
  return {
    type: "DELETE_RESPONSE",
    responseID,
  }
}

export function deletePost(postID) {
  return {
    type: "DELETE_POST",
    postID,
  }
}

export function controlAlert(bool) {
  return {
    type: "ALERT_STATE_CHANGE",
    bool,
  }
}

/* thunk functions */
/* const api = "http://localhost:7777" */
/*const api = "https://libya-api-heroku.herokuapp.com"*/
const api = "https://libya-api.vercel.app/api"

const headers = {
  Authorization: "letmein",
  Accept: "application/json",
  "Content-Type": "application/json",
}

/* localStorage key */
export const USER_KEY = "User"

export function itemsFetchCategories() {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/categories`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })

      .then((response) => response.json())

      //.then(data => data.categories)
      //.then((response) => console.log(response))
      .then((items) => dispatch(categoriesFetchDataSuccess(items)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function itemsFetchStaticCategories() {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/static-category-list`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })

      .then((response) => response.json())

      //.then(data => data.categories)
      //.then((response) => console.log(response))
      .then((items) => dispatch(staticCategoriesFetchDataSuccess(items)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function itemsFetchPostsByCategory(category) {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/categories/${category}`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((items) => dispatch(postsFetchDataSuccess(items)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function itemsFetchSinglePost(id) {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/posts/${id}`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((item) => dispatch(singlePostFetchDataSuccess(item)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function addNewPost(
  title,
  body,
  category,
  categoryID,
  authorEmail,
  authorName,
  image
) {
  return (dispatch) => {
    fetch(`${api}/add-post`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        title: title,
        body: body,
        category: category,
        categoryID: categoryID,
        authorName: authorName,
        authorEmail: authorEmail,
        image: image,
        date: new Date().toLocaleDateString("en-GB"),
        timestamp: Date.now(),
      }),
    })
      //.then((response) => console.log(response.json()))
      .then((response) => response.json())
      .then((item) => dispatch(addPost(item)))
  }
}

export function addNewCategory(category) {
  return (dispatch) => {
    fetch(`${api}/add-category`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        name: category,
      }),
    }).then(() =>
      dispatch(
        addCategory([
          {
            category: category,
          },
        ])
      )
    )
  }
}

export function saveUser(user) {
  return (dispatch) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
    dispatch(updateUser(user))
  }
}

export function checkStorageForUser() {
  return (dispatch) => {
    let localUser = localStorage.getItem(USER_KEY)
    if (localUser) {
      console.log("There is user in localstorage")
      const parsedLocalUser = JSON.parse(localUser)
      // console.log('Here is what is in storage: ' + parsedLocalUser)
      if (parsedLocalUser != null) {
        dispatch(updateUser(parsedLocalUser))
      }
    } else {
      console.log("No user in localstorage")
    }
  }
}

export function removeUser() {
  return (dispatch) => {
    localStorage.removeItem(USER_KEY)
    const emptyUser = {}
    dispatch(updateUser(emptyUser))
  }
}

export function itemsFetchComments(id) {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/comments/${id}`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((items) => dispatch(commentsFetchDataSuccess(items)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function addNewComment(body, authorName, authorEmail, parentId, image) {
  return (dispatch) => {
    fetch(`${api}/add-comment`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        parentID: parentId,
        body: body,
        authorName: authorName,
        authorEmail: authorEmail,
        image: image,
        date: new Date().toLocaleDateString("en-GB"),
      }),
    })
      .then((response) => response.json())
      .then((item) => dispatch(addComment(item)))
  }
}

export function deleteExistingComment(commentId) {
  return (dispatch) => {
    fetch(`${api}/comments/${commentId}`, {
      headers,
      method: "DELETE",
    }).then(() => dispatch(deleteComment(commentId)))
  }
}

export function updateExistingComment(
  commentId,
  body,
  authorName,
  authorEmail,
  parentId
) {
  return (dispatch) => {
    fetch(`${api}/comments/${commentId}`, {
      headers,
      method: "PUT",
      body: JSON.stringify({
        parentID: parentId,
        body: body,
        authorName: authorName,
        authorEmail: authorEmail,
        date: new Date().toLocaleDateString("en-GB"),
      }),
    }).then(() => dispatch(updateComment(commentId, body)))
  }
}

export function addNewResponse(
  commentID,
  postID,
  body,
  authorName,
  authorEmail,
  originalCommentAuthorEmail
) {
  return (dispatch) => {
    fetch(`${api}/add-response`, {
      headers,
      method: "POST",
      body: JSON.stringify({
        commentID: commentID,
        postID: postID,
        body: body,
        authorName: authorName,
        authorEmail: authorEmail,
        date: new Date().toLocaleDateString("en-GB"),
        originalCommentAuthorEmail: originalCommentAuthorEmail,
      }),
    })
      .then((response) => response.json())
      .then((item) => dispatch(addResponse(item)))
  }
}

export function itemsFetchResponses(postID) {
  return (dispatch) => {
    dispatch(itemsIsLoading(true))
    fetch(`${api}/responses/${postID}`, { headers })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        dispatch(itemsIsLoading(false))
        return response
      })
      .then((response) => response.json())
      .then((items) => dispatch(responsesFetchDataSuccess(items)))
      .catch(() => dispatch(itemsHasErrored(true)))
  }
}

export function deleteExistingResponse(responseID) {
  return (dispatch) => {
    fetch(`${api}/responses/${responseID}`, {
      headers,
      method: "DELETE",
    }).then(() => dispatch(deleteResponse(responseID)))
  }
}

export function deleteExistingPost(postId) {
  return (dispatch) => {
    fetch(`${api}/posts/${postId}`, {
      headers,
      method: "DELETE",
    }).then(() => dispatch(deletePost(postId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js